
import React from "react";
import { RequestScreen } from "../Request/RequestScreen";

export const PreviewTemplateScreen = () => {
  return <RequestScreen />;
};
